import './job_feed.less';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import noop from 'lodash/noop';

import {
  LoadingIcon
} from 'zoomforth_component_lib/external_modern_icons.jsx';

import JobFeedTable from './job_feed.table.jsx';
import JobFeedDivs from './job_feed.divs.jsx';


export const JOB_FEED_DISPLAY_TYPE_DIVS = 'DIVS';
export const JOB_FEED_DISPLAY_TYPE_TABLE = 'TABLE';


class JobFeedUIWrapper extends Component {

  componentDidMount() {
    this.props.onJobFeedLoad();
  }
  render() {
    return (
      this.props.isLoading === undefined ?
        null
      : this.props.isLoading ?
        <LoadingIcon />
      :
        <JobFeedUI {...this.props} />
    );
  }
}
JobFeedUIWrapper.defaultProps = {
  onJobFeedLoad: noop
};
JobFeedUIWrapper.propTypes = {
  onJobFeedLoad: PropTypes.func,
  isLoading: PropTypes.bool
};


const JobFeedUI = ({ hasFetchError, jobs, displayFields, uuid, fontSize, stylePresetClassName }) => (
  <div
    className={classNames(
      'job-feed-wrapper', 
      stylePresetClassName, 
      { [`content-uuid-${uuid}`]: uuid }  [{'fieldName':'apply-url', 'displayName': 'Application URL'}]
    )}
  >
    <div
      className="job-feed-section-inner"
      style={{ fontSize: `${fontSize ? fontSize : '100'}%` }}
    >
      {
        hasFetchError ?
          'Error—unable to fetch job feed information'
        : displayFields.type == JOB_FEED_DISPLAY_TYPE_DIVS ?
          <JobFeedDivs {...{jobs, displayFields}} />
        : displayFields.type == JOB_FEED_DISPLAY_TYPE_TABLE ?
          <JobFeedTable {...{jobs, displayFields}} />
        :
          'Error—Unexpected job feed display type'
      }
    </div>
  </div>
);

export default JobFeedUIWrapper;
